export default __webpack_public_path__ + "static/favicon-27a724c9a3ea89596f8dd12a87481c60.ico";